import React, { useMemo } from 'react';
import { formatNumber } from '../utils.js';
import { classNames } from '../../../helpers/classnames.js';
import { Typography } from '../../Typography/Typography.js';

var BadgeContent = function (_a) {
    var count = _a.count, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.warning, warning = _c === void 0 ? false : _c, _d = _a.hideBadgeContent, hideBadgeContent = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? 'small' : _e, stanalone = _a.stanalone;
    var badgeContent = useMemo(function () { return formatNumber(count); }, [count]);
    return (React.createElement(Typography, { "data-testid": "BadgeContent", className: classNames('dsb_badge', "dsb_badge--".concat(size), {
            'dsb_badge--error': error,
            'dsb_badge--exclamation': warning,
            'dsb_badge--standalone': stanalone
        }), variant: "overline" }, !hideBadgeContent && (warning ? '!' : badgeContent)));
};

export { BadgeContent };
